import React, { Component } from "react";
import styles from "./footer.module.css";

 

export class Footer extends Component {
  render() {    

    return (
      <div className={styles.footers}>
        <div>Developed by Avinash Bawage</div>
      </div>
    );
  }
}

export default Footer;
